/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-07-13 11:52:35
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\login\locales\zh-CN.ts
 */
export default {
  'page.user.login.form-item-username': '输入邮箱/手机号登录',
  'page.user.login.form-item-username.required': '请输入用户名',
  'page.user.login.form-item-password': '输入密码',
  'page.user.login.form-item-password.required': '请输入密码',
  'page.user.login.form.title': '账号登录',
  'page.user.login.form.btn-submit': '登录',
  'page.user.login.form.btn-jump': '注册新账号',
  'page.user.login.form.login-error': '用户名或密码错误！',
  'page.user.login.form.login-success': '登录成功！',
  'page.user.login.form.forgetmsg': '忘记密码',
  'page.user.login.form.verifica': '请输入图形码',
};
